import { Link } from 'react-router-dom';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import OpenIcon from '@mui/icons-material/OpenInFull';
import { ClickAwayListener, List, ListItemIcon, ListItemText,Menu, MenuItem, Paper, Popper } from '@mui/material';
import { Operations } from 'common/types/TypeDefs';

interface Action {
    operation: Operations;
    handleOperation?: () => void;
    disabled?: boolean;
    urlToOpen?: (() => string | null);
}

const iconSwitcher = (action: Operations) => {
    switch (action) {
        case Operations.Open:
            return <OpenIcon/>;
        case Operations.Edit:
            return <EditIcon/>;
        case Operations.Delete:
            return <DeleteIcon/>;
        default:
            return undefined;
    }
};


export const ActionsPopper = (props: { anchorEl: HTMLElement | null, handleClosePopper: () => void, actions: Action[] }) => (
    <Popper
        open={Boolean(props.anchorEl)}
        anchorEl={props.anchorEl}
        placement={'bottom-end'}
    >
        <ClickAwayListener
            onClickAway={props.handleClosePopper}
        >
            <Paper>
                <List>
                    <Menu
                        anchorEl={props.anchorEl}
                        open={Boolean(props.anchorEl)}
                        onClose={props.handleClosePopper}
                    >
                        {props.actions.map((action) => (
                            <MenuItem
                                key={action.operation}
                                onClick={action.handleOperation}
                                disabled={action.disabled}>
                                <ListItemIcon>
                                    {iconSwitcher(action.operation)}
                                </ListItemIcon>

                                <ListItemText
                                    primary={
                                        action.urlToOpen ? (
                                            <Link
                                                to={action.urlToOpen() ?? ''}
                                                style={{ textDecoration: 'none', color: 'inherit' }}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {action.operation}
                                            </Link>) : (
                                            action.operation
                                        )
                                    }
                                />
                            </MenuItem>
                        ))}
                    </Menu>
                </List>
            </Paper>
        </ClickAwayListener>
    </Popper>
);
